import { useHomeBanner, useServiceProduct, useFunctionTeachingLearning, useLearningToolsEditor, useMaterialLibrary } from '@/src/api/getData';
import CardsCol3 from '@/components/cards-col-3';

const ProductView: any = ({ language = '' }) => {
    const { data: banner } = useHomeBanner(language);
    const { data: serviceProduct } = useServiceProduct(language);
    const { data: functionTeachingLearning } = useFunctionTeachingLearning(language);
    const { data: learningToolsEditor } = useLearningToolsEditor(language);
    const { data: materialLibrary } = useMaterialLibrary(language);

    let pageData = serviceProduct?.data ?? {};
    let introductionData = pageData.Cards ?? [];
    let videos = serviceProduct?.data?.video?.[0]?.Video || []
    let functionTeachingLearningData = functionTeachingLearning?.data || {};

    let learningToolsEditorData = learningToolsEditor?.data || {};
    let learningToolsHeader = learningToolsEditorData.OtherTools?.Header || {};
    let learningToolsCards = learningToolsEditorData.OtherTools?.Card || [];
    let editorSpecificationsHeader = learningToolsEditorData.Product_specifications?.Header || {};
    let editorSpecifications = learningToolsEditorData.Product_specifications?.tableEditor || [];

    let materialLibraryData = materialLibrary?.data || {};
    let materialLibraryHeader = materialLibraryData.MaterialLibrary?.Header || {};
    let materialLibraryCards = materialLibraryData.MaterialLibrary?.Cards || [];
    let materialLibraryBall = materialLibraryData.MaterialLibrary?.Ball || [];
    const locateSrc = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? '/backend/public' : '';

    return (
        <main className='main bg-1' id="start">
            <section className="banner-section container">
                {banner?.data?.banner && banner.data.banner.map((item: any, index: number) => (
                    item.Category === "AI Learning Management System" && (
                        <div className='banner special bg-1' key={index}>
                            <div className="banner-image">{item.image && <img src={`${locateSrc}${item.image.url}`} alt={item.title} />}</div>
                            <div className="banner-content">
                                <img src={`${locateSrc}${banner.data.Logo.url}`} alt={banner.data.Logo.alternativeText} />
                                <h1>{item.title}</h1>
                                <p>{item.description}</p>
                            </div>
                        </div>
                    )))}
            </section>

            {introductionData.length > 0 && (
                <section className="production-introduction container">
                    <div>
                        {
                            introductionData.map((item: any, index: number) => {
                                return (
                                    <div className="item" key={index}>
                                        <div className="icon">
                                            <img src={`${locateSrc}${item.icon.url}`} alt={item.title} />
                                        </div>
                                        <div className="text">
                                            <h2>{item.title}</h2>
                                            <div>{item.Content}</div>
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </section>
            )}

            <section className="introductionVideo">
                <div className='container'>
                    {videos.map((item: any, index: number) => {
                        return (
                            <div key={index}>
                                <video controls autoPlay muted loop playsInline>
                                    <source src={`${item.url}`} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        );
                    })}
                </div>
            <section className='functionIntroduction container'>
                <CardsCol3 
                    itemsData={functionTeachingLearningData.TeachingLearning || []} 
                    language={language} 
                />
            </section>
            </section>

            <section className='otherLearningTools container'>
                <h2 className='h2-main'>{learningToolsHeader.ColorOne}{language=="en"?" ":""}<span>{learningToolsHeader.ColorTwo}</span></h2>
                <div className='item-container core-products'>

                    {learningToolsCards.map((item: any, index: number) => {
                        return (
                            <div className='item' key={index}>
                                <div>
                                    <div className='icon'><img src={`${locateSrc}${item.Icon.url}`} alt={item.Title} /></div>
                                    <div className='title'>{item.Title}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </section>
            <section className="gradientCard container">
                <div className="gradientCard-content">
                    <div className="pattern"></div>
                    <div className="content">
                        <h2>{editorSpecificationsHeader.ColorOne}<br /><span>{editorSpecificationsHeader.ColorTwo}</span></h2>
                        <div className='lists lists-v1' dangerouslySetInnerHTML={{ __html: editorSpecifications }}>
                        </div>
                    </div>
                </div>
            </section>
            <section className="materialLibrary container">
                <h2 className='h2-main'>{materialLibraryHeader.ColorOne}{language=="en"?" ":""}<span>{materialLibraryHeader.ColorTwo}</span></h2>
                <div className="text-container">
                    {materialLibraryHeader.Introduction}
                </div>
                <div className="list-card">
                    {materialLibraryCards.map((item: any, index: number) => {
                        return (
                            <div className='item' key={index}>
                                <div>{item.Title}</div>
                            </div>
                        );
                    })}
                </div>
            </section>
            <section className='orange-ball container'>
                {materialLibraryBall.map((item: any, index: number) => {
                    return (
                        <div className='ball' key={index}>
                            <div>
                                <div className='t1'>{item.Title_small}</div>
                                <div className='t2'>{item.Title_big}</div>
                                <div className='t3'>{item.Title_small2}</div>
                            </div>
                        </div>
                    );
                })}
            </section>
        </main>
    );
}

export default ProductView;